import qs from 'qs';
import { signInWithRedirect } from 'aws-amplify/auth';
import { userAuthStatusMap } from 'components/UserAuthManager/helpers';

/**
 * Signs in the user using Google as the identity provider
 *
 * @param {object} oLocation - The location object from react-router-dom
 * @param {string} sIdentityProvider - The Cognito federated identity provider (Google, LoginWithAmazon, Facebook, Apple)
 * @param {string} userAuthStatus - The current user authentication status (e.g. "not-signed-in", "signed-in-unmatched", "signed-in-matched")
 */
const fnSignIn = async (oLocation, sIdentityProvider, userAuthStatus) => {
  const oSignInConfig = {
    provider: sIdentityProvider,
  };

  let sRedirect = null;
  if (oLocation.search) {
    const oQueryParams = qs.parse(oLocation.search, {
      ignoreQueryPrefix: true,
    });
    if (oQueryParams.redirect) {
      sRedirect = oQueryParams.redirect;
      const oCustomState = { redirect: sRedirect };
      const sCustomState = JSON.stringify(oCustomState);
      oSignInConfig.customState = sCustomState;
    }
  }

  switch (userAuthStatus) {
    case userAuthStatusMap.notSignedIn:
      signInWithRedirect(oSignInConfig);
      return;
    case userAuthStatusMap.signedInUnmatched:
      window.location.assign('/sign-up');
      return;
    case userAuthStatusMap.signedInMatched:
      window.location.assign(sRedirect || '/main');
      return;
    default:
      console.warn('fnSignIn - Unknown user auth status:', userAuthStatus);
      break;
  }
};

export default fnSignIn;
